import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ParentTemplateFolder from "@/services/template/parent-template-folder";
import type { EditParentTemplateFolder } from "@/dtos/ParentTemplateFolder.dto";

export function useUpdateParentTemplateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: EditParentTemplateFolder) => {
      const response = await ParentTemplateFolder.editParentTemplateFolder(data);

      if (response.data.status) {
        return response.data.data;
      }

      throw new Error(response.data.msg || "Failed to update parent template folder");
    },
    onSuccess: () => {
      // Invalidate parent template folders query to refetch
      queryClient.invalidateQueries({ queryKey: ["parentTemplateFolders"] });
    },
  });
}
